// 内置测试账号白名单
// 这 10 个手机号 + 长期密码 + 对应实名身份证号用于测试人员快速登录，
// 注册时间统一设置在 2026 年 4 月份（5 月之前），模拟历史注册。
// 注意：这些账号不能再次走注册流程占用。
export const TEST_ACCOUNTS = [
  {
    phone: '15380440382',
    password: 'xicheng20180103',
    idCard: '320924198911066168',
    registeredAt: '2026-04-10T10:30:00+08:00'
  },
  {
    phone: '17302559684',
    password: 'xicheng20180103',
    idCard: '130526200010093412',
    registeredAt: '2026-04-11T10:30:00+08:00'
  },
  {
    phone: '17361908096',
    password: 'xicheng20180103',
    idCard: '320382199603305548',
    registeredAt: '2026-04-12T10:30:00+08:00'
  },
  {
    phone: '15380972940',
    password: 'xicheng20180103',
    idCard: '340802200008180028',
    registeredAt: '2026-04-13T10:30:00+08:00'
  },
  {
    phone: '18061292253',
    password: 'xicheng20180103',
    idCard: '320382199603305548',
    registeredAt: '2026-04-14T10:30:00+08:00'
  },
  {
    phone: '18114031530',
    password: 'xicheng20180103',
    idCard: '320123199311141026',
    registeredAt: '2026-04-15T10:30:00+08:00'
  },
  {
    phone: '18114468103',
    password: 'xicheng20180103',
    idCard: '320381199603029217',
    registeredAt: '2026-04-16T10:30:00+08:00'
  },
  {
    phone: '17327082616',
    password: 'xicheng20180103',
    idCard: '340521199412122329',
    registeredAt: '2026-04-17T10:30:00+08:00'
  },
  {
    phone: '18136849304',
    password: 'xicheng20180103',
    idCard: '32128119920918242X',
    registeredAt: '2026-04-18T10:30:00+08:00'
  },
  {
    phone: '17302547764',
    password: 'xicheng20180103',
    idCard: '340505199503020627',
    registeredAt: '2026-04-19T10:30:00+08:00'
  }
];

// 判断手机号是否属于测试账号白名单
export const isTestAccountPhone = (phone) => {
  const target = String(phone || '').trim();
  return TEST_ACCOUNTS.some((item) => item.phone === target);
};

// 匹配测试账号：手机号 + 密码完全一致才返回用户对象，否则返回 null
// 返回的对象包含身份证号和注册时间，可直接交给 saveAuthedUser
export const matchTestAccount = (phone, password) => {
  const targetPhone = String(phone || '').trim();
  const targetPassword = String(password || '');
  const account = TEST_ACCOUNTS.find((item) => item.phone === targetPhone);
  if (!account) return null;
  if (account.password !== targetPassword) return null;
  return {
    phone: account.phone,
    idCard: account.idCard,
    registeredAt: account.registeredAt
  };
};
